// ** React Imports
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// ** MUI Components
import {
  IconButton,
  Button,
  Box,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  MenuItem,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Checkbox,
  Tooltip,
} from "@mui/material";
import FormLabel from "@mui/material/FormLabel";
import Grid from "@mui/material/Grid";
import { LocalizationProvider } from "@mui/x-date-pickers-pro";
import { AdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers-pro";
import { DateTimePicker } from '@mui/x-date-pickers-pro';
import dayjs from "dayjs";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Chip from "@mui/material/Chip";

import ListItemText from "@mui/material/ListItemText";

// Custom Component Imports
import CustomTextField from "../../../components/mui/text-field";
import CustomAutocomplete from "components/mui/autocomplete";

// ** Icon Imports
import Icon from "../../../components/icon";

import { SaveSchedule, GetSchedule, changeStatus } from "../logic/SchedulingLogic";
import { GetEmployees } from "screens/Employees/logic/GetEmployees";
import { SaveAssessmentAmount } from "screens/Invoice/logic/SaveInvoice";
import { GetAssessmentAmount } from "screens/Invoice/logic/GetAssessmentAmount";

const ScheduleAssessment = ({ 
  open,
  handleClose, 
  entity, 
  requestID, 
  requestType, 
  setLoading, 
  setSchedulingReq, 
  scheduleStatus, 
  fetchRequests
}) => {
  const [scheduleStep, setScheduleStep] = useState(1);
  const [sendReminder, setSendReminder] = useState(false);
  const [selectedDateTime, setSelectedDateTime] = useState(null);
  const [assessmentType, setAssessmentType] = useState("On-Call");
const [employee, setEmployee] = useState({ assignees: [] });
  const [reminderSelection, setReminderSelection] = useState("select"); // Track selected reminder
  const [existingSchedule, setExistingSchedule] = useState(null);
  const [existingDateTime, setExistingDateTime] = useState(existingSchedule);
  const [buttonStatus, setButtonStatus] = useState(true);
  const navigate = useNavigate();
  const [employeesList, setEmployeesList] = useState([]);
  const [initialValues, setInitialValues] = useState({
    employee: null,
    selectedDateTime: null,
    sendReminder: false,
    reminderSelection: "select",
    assessmentAmount: '',
  });
  const [chargeReq, setChargeReq] = useState(false);
  const [assessmentAmount, setAssessmentAmount] = useState('');
  const [errorAmount, setErrorAmount] = useState(false);
  const [workReq, setWorkReq] = useState();

  useEffect(() => {
    const fetchAssessmentAmount = async () => {
      try{
        const response = await GetAssessmentAmount(requestID)

        if(response.result && response.result.length > 0){
          setChargeReq(true);
          const filteredWorkReq = response.result.find((wr) => wr.subServiceID === 0);
          
          setWorkReq(filteredWorkReq);
          setAssessmentAmount(filteredWorkReq.jobs[0].flatRate);
          setInitialValues((prev) => ({
            assessmentAmount: filteredWorkReq.jobs[0].flatRate
          }))
        }
      }catch(error){
        console.error(error)
      }
    }

    if(requestID){
      fetchAssessmentAmount()
    }
  }, [requestID])
  

  const handleEmployeeChange = (field, value) => {
    setEmployee((prevEmployee) => ({
      ...prevEmployee,
      [field]: value,
    }));
  };

  const fetchEmployees = async () => {
      try {
        let emp = await GetEmployees(0, navigate);               
        setEmployeesList(emp);                
      } catch (error) {
        console.error("Error fetching employee data:", error);
      }finally {
        setLoading(false); 
      }
  };

  useEffect(() => {
    fetchEmployees();
  }, []);

  useEffect(() => {
    if(scheduleStep === 1){
      fetchSchedule();
    }
  }, []);

  // useEffect(() => {
  //   if (!selectedDateTime || !existingDateTime) return;
  
  //   const isDateSame = dayjs(selectedDateTime).isSame(dayjs(existingDateTime));
  
  //   if (scheduleStep === 1 && isDateSame) {
  //     setButtonStatus(true); 
  //   } else {
  //     setButtonStatus(false);
  //   }
  // }, [selectedDateTime, existingDateTime, scheduleStep]);

  useEffect(() => {
  if (open) {
    setScheduleStep(1);
    // Optionally reset other state here if needed
  }
  }, [open]);

const fetchSchedule = async () => {
  const data = await GetSchedule({ workReqID: 0, entityID: requestID });
  if (data?.result?.length > 0) {
    const schedule = data.result.find((sch) => sch.subServiceID === 0);
    if (schedule) {
      setExistingSchedule(schedule);
      
      if (schedule.jobs?.length > 0) {
        const job = schedule.jobs[0];
        // Combine scheduleStartDate and scheduleStartTime to create datetime
        let jobTime = null;
        if (job.scheduleStartDate && job.scheduleStartTime) {
          const dateStr = dayjs(job.scheduleStartDate).format('YYYY-MM-DD');
          const timeStr = job.scheduleStartTime;
          jobTime = dayjs(`${dateStr}T${timeStr}`);
        } else if (job.scheduleStartDate) {
          jobTime = dayjs(job.scheduleStartDate);
        }
        
        if (jobTime) {
          setExistingDateTime(jobTime);
          setSelectedDateTime(jobTime);
        }
        setAssessmentType(job.scheduleMethod || "On-Call");

        // Properly set employee data
       let assigneeIDs = [];
        if (job.assignees?.length > 0) {
          assigneeIDs = job.assignees.map(a =>
            typeof a === "object" ? a.employeeID : a
          );
          setEmployee({ assignees: assigneeIDs });
        }


          if (job.reminder) {
            setSendReminder(true);
            setReminderSelection(job.reminder);
          } else {
            setSendReminder(false);
            setReminderSelection("select");
          }
         setInitialValues(prev => ({
  ...prev,
  employee: assigneeIDs,
  selectedDateTime: jobTime,
  sendReminder: !!job.reminder,
  reminderSelection: job.reminder || "select"
}));

        }
      }
      setButtonStatus(true);
    }
  };

  const handleChangeDateTime = (newValue) => {
    (scheduleStep === 1 &&  dayjs(selectedDateTime).isSame(dayjs(existingDateTime))) ? setButtonStatus(true) : setButtonStatus(false)
    setSelectedDateTime(newValue)
  }

  const handleSendReminder = () => {
    setSendReminder(!sendReminder);
  };

  const handleReminderChange = (e) => {
    setReminderSelection(e.target.value);
  };

  const calculateReminderTime = (selectedDateTime, reminder) => {
    if (!selectedDateTime || reminder === "select") return null;

    switch (reminder) {
      case "1 week before":
        return dayjs(selectedDateTime).subtract(1, "week").format('YYYY-MM-DDTHH:mm:ss');
      case "1 day before":
        return dayjs(selectedDateTime).subtract(1, "day").format('YYYY-MM-DDTHH:mm:ss');
      case "1 hour before":
        return dayjs(selectedDateTime).subtract(1, "hour").format('YYYY-MM-DDTHH:mm:ss');
      case "30 minutes before":
        return dayjs(selectedDateTime).subtract(30, "minute").format('YYYY-MM-DDTHH:mm:ss');
      case "15 minutes before":
        return dayjs(selectedDateTime).subtract(15, "minute").format('YYYY-MM-DDTHH:mm:ss');
      default:
        return null;
    }
  };

  const resetInitialValues = () => {
    setScheduleStep(1);
    setSendReminder(false);
    setSelectedDateTime(null);
    setAssessmentType("On-Call");
    setEmployee("");
    setReminderSelection("select");
    setSchedulingReq(false);
  };

  const handleNext = () => {
    if (!selectedDateTime) {
      toast.error("Please select date and time to proceed", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
         theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
      });
      return;
    }
  
    if (scheduleStep === 1) {
      if(chargeReq && (!assessmentAmount || assessmentAmount === '' || assessmentAmount === 0)){
        setErrorAmount(true);
        return;
      }else{
        // Simply move to step 2 without closing the popup immediately
        handleSaveSchedule();
        setScheduleStep(2);      
      }
    } else if (scheduleStep === 2) {
      // resetInitialValues();
      changeStatusToRescheduled();
      handleClose();
      setErrorAmount(false);
      if(entity === "convert"){
        localStorage.setItem("fromConversion", "true");
        navigate(`/assessments/detail/${requestID}`);
      }

    }
  };

  const handleCloseAndSkip = () => {
    if (scheduleStep === 1 && entity === "convert") {
      handleClose();
      localStorage.setItem("fromConversion", "true");
      navigate(`/assessments/detail/${requestID}`);
    } else {
      handleClose();
    }
  };

  // const handleSaveAssessmentAmount = async (updatedWorkReq) => {
  //   try{
  //     await SaveAssessmentAmount(updatedWorkReq, navigate)
  //   }catch(error){
  //     console.error('Error saving Assessment amount: ', error)
  //   }
  // }

 const handleSaveSchedule = async () => {
    let flatRate = 0;

    // Validate amount if charge is required
    if (chargeReq) {
        // First check if amount exists
        if (!assessmentAmount && assessmentAmount !== 0) {
            setErrorAmount(true);
            return;
        }

        // Convert to string and clean
        const amountString = assessmentAmount?.toString() || '';
        const cleanedAmount = amountString.replace(/,/g, '').trim();

        // Validate the numeric value
        if (!cleanedAmount || isNaN(cleanedAmount) || parseFloat(cleanedAmount) <= 0) {
            setErrorAmount(true);
            return;
        }

        flatRate = parseFloat(cleanedAmount);
        setErrorAmount(false); // Reset error if validation passes
    }

    
    const reminderTime = calculateReminderTime(selectedDateTime, reminderSelection);

    const scheduleObject = {
      workReqID: existingSchedule ? existingSchedule.workReqID : 0,
      entityID: Number(requestID),
      subServiceID: 0,
      bundleID: 0,
      areaIDs: [0],
      description: null,
      specialInstructions: [],
      jobs: [
        {
          jobID:
            existingSchedule && existingSchedule.jobs && existingSchedule.jobs.length > 0
              ? existingSchedule.jobs[0].jobID
              : 0,
          flatRate: flatRate,
          billingType: null,
          occurrenceNo: 0,
          // Use separate date and time fields
          scheduleStartDate: selectedDateTime ? dayjs(selectedDateTime).format("YYYY-MM-DD") : null,
          scheduleStartTime: selectedDateTime ? dayjs(selectedDateTime).format("HH:mm:ss") : null,
          scheduleEndDate: selectedDateTime ? dayjs(selectedDateTime).add(1, "hour").format("YYYY-MM-DD") : null,
          scheduleEndTime: selectedDateTime ? dayjs(selectedDateTime).add(1, "hour").format("HH:mm:ss") : null,
          scheduleMethod: assessmentType,
          reminder: sendReminder ? reminderSelection : null,
          reminderTime: reminderTime,
          assignees: employee?.assignees || [],
          status:'Scheduled',
        },
      ],
      jobType: "One Time",
      billingType: "Fixed",
      frequency: null,
      numberOfOccurrences: 0,
      firstOccurrenceDate: null,
      excludeWeekends: null,
      excludeHolidays: null,
      daysOfWeek: [0],
      weekConfiguration: null,
      monthConfiguration: [0],
      intervalDays: 0,
    };

    const toasterMessage = existingSchedule ? "Assessment Rescheduled Successfully!" : "Assessment Scheduled Successfully!"

    setLoading(true);
    try{
      const response = await SaveSchedule(scheduleObject, toasterMessage)
      // if(!response.isError && chargeReq){
      //   if(!assessmentAmount || assessmentAmount === '' || assessmentAmount === 0){
      //     setErrorAmount(true);
      //   }else{
      //     setErrorAmount(false);
      //     const updatedWorkReq = {
      //       ...workReq,
      //       jobs: [{
      //         ...workReq.jobs[0],
      //         assignees: employee?.assignees || [],
      //         flatRate: flatRate
      //       }]
      //     }
      //     handleSaveAssessmentAmount(updatedWorkReq);
      //   }
      // }
    }catch(error){
      console.error("Error saving schedule:", error);
    }finally{
      setLoading(false);
    }
  };

  const [isRescheduleMode, setIsRescheduleMode] = useState(false);
  

  useEffect(() => {
    if (open) {
      const checkExistingSchedule = async () => {
        const data = await GetSchedule({ workReqID: 0, entityID: requestID });
        const schedule = data.result.find((sch) => sch.subServiceID === 0);
        setIsRescheduleMode(!!schedule);
      };
      if(requestID){
        checkExistingSchedule();
      }
    }
  }, [open, requestID]);

  const getPopupTitle = () => {
    if (scheduleStep === 1 && entity === 'convert') {
      return "Assessment Scheduled";
    }
    return isRescheduleMode ? "Reschedule Assessment" : "Schedule Assessment";
  };

  useEffect(() => {
    return () => {
      if (open) {
        fetchSchedule();
      }
    };
  }, [open]);

  const changeStatusToRescheduled = async () => {
    const assessmentTypeStatus = assessmentType === "On-Call" ? "Phone Scheduled" : "On-Site Scheduled";
    const newStatus = existingSchedule ? "Rescheduled" : assessmentTypeStatus;
  
    try {
      const response = await changeStatus(requestID, newStatus);
      // console.log(response)
       if (response) { 
        // console.log('Status updated successfully'); 
        fetchRequests(requestID, false);
      }
    } catch (error) {
      console.error('Error updating status:', error);
    }
  }
  
  const formatDate = (date) => {
    if (!date) return "";
    return date.format("dddd, MMMM D, YYYY h:mm A");
  };

  const labels = {
    convert: {
      1: "Schedule",
      2: "Okay",
    },
    schedule: {
      1: scheduleStatus,
      2: "Okay",
    },
  };

  const handleChargeReq = (checked) => {
    setChargeReq(checked);
  }

 const handleChangeAmount = (value) => {
  let processedValue = value;

  const numericString = value.replace(/[^0-9.]/g, '');
  
  const parts = numericString.split('.');
  let wholePart = parts[0];
  const decimalPart = parts.length > 1 ? `.${parts[1]}` : '';

  wholePart = wholePart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  processedValue = wholePart + decimalPart;

  setAssessmentAmount(processedValue);
  
  // Clear error if amount is being entered
  if (value && value.trim() !== '') {
    setErrorAmount(false);
  }
};
  useEffect(() => {
  if (
    initialValues.selectedDateTime === null ||
    initialValues.employee === null ||
    selectedDateTime === null
  ) {
    return; // Don't run until all initial values are loaded
  }

    const dateChanged = !dayjs(selectedDateTime).isSame(dayjs(initialValues.selectedDateTime));
    const employeeChanged =
      JSON.stringify(employee?.assignees || []) !== JSON.stringify(initialValues.employee || []);
    const reminderChanged =
      sendReminder !== initialValues.sendReminder ||
      reminderSelection !== initialValues.reminderSelection;

    const amountChanged = assessmentAmount !== initialValues.assessmentAmount;

    const hasChanges = dateChanged || employeeChanged || reminderChanged || amountChanged;

    setButtonStatus(!hasChanges); // disable = true, enable = false
  }, [selectedDateTime, employee, sendReminder, reminderSelection, initialValues, assessmentAmount]);

  return (
    <Dialog
      fullWidth={true}
      maxWidth="sm"
      open={open}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
      sx={{
        "& .MuiDialog-paper": {
          maxWidth: "500px",
          width: "90%",
        },
      }}
    >
      <DialogTitle
        sx={{
          borderBottom: "1px solid #D9D9D9",
          paddingBottom: "20px !important",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h4" fontWeight="bold">
            {
              // (scheduleStep === 1 && entity === 'convert') ?
              // "Assessment Scheduled" :
              // `${scheduleStatus} Assessment`
              getPopupTitle()
            }
          </Typography>
          <Tooltip title="Close">
            <IconButton onClick={handleClose}>
              <Icon icon="tabler:x" />
            </IconButton>
          </Tooltip>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={5}>
          {scheduleStep === 1 && (
            <>
              <Grid item xs={12}>
                <FormControl>
                  <RadioGroup
                    row
                    name="assessmentType"
                    value={assessmentType}
                    onChange={(e) => setAssessmentType(e.target.value)}
                  >
                    <FormControlLabel
                      value="On-Call"
                      control={<Radio color="success" />}
                      label="Phone Assessment"
                    />
                    <FormControlLabel
                      value="On-Site"
                      control={<Radio color="success" />}
                      label="Onsite Assessment"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
            <Grid item xs={12}>
                <CustomAutocomplete
                  multiple
                  fullWidth
                  disableCloseOnSelect
                  options={(employeesList || []).sort((a, b) => 
                    `${a.firstName || ''} ${a.lastName || ''}`.localeCompare(`${b.firstName || ''} ${b.lastName || ''}`)
                  )}
                  getOptionLabel={(option) =>
                    `${option?.firstName || ''} ${option?.lastName || ''}`.trim()
                  }
                  value={employeesList.filter((emp) =>
                    (employee?.assignees || []).some(
                      (id) =>
                        emp.employeeID === id ||
                        (typeof id === "object" &&
                          emp.employeeID === id.employeeID)
                    )
                  )}
                  onChange={(event, newValue) => {
                    const selectedIDs = newValue.map((item) => item.employeeID);
                    handleEmployeeChange("assignees", selectedIDs);
                  }}
                  isOptionEqualToValue={(option, value) =>
                    option?.employeeID === value?.employeeID
                  }
                  filterOptions={(options, { inputValue }) => {
                    const searchTerm = inputValue.toLowerCase();
                    return options.filter(option => 
                      `${option.firstName || ''} ${option.lastName || ''}`.toLowerCase().includes(searchTerm)
                    );
                  }}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox
                        style={{ marginRight: 8 }}
                        checked={(employee?.assignees || []).some(
                          (id) =>
                            option.employeeID === id ||
                            (typeof id === "object" &&
                              option.employeeID === id.employeeID)
                        )}
                      />
                      <ListItemText
                        primary={`${option.firstName} ${option.lastName}`}
                      />
                    </li>
                  )}
                  renderTags={(value, getTagProps) => {
                    const visibleCount = 2;
                    const extraCount = value.length - visibleCount;

                    return (
                      <>
                        {value.slice(0, visibleCount).map((item, index) => (
                          <Chip
                            key={index}
                            label={
                              <Typography
                                variant="body2"
                                sx={{
                                  maxWidth: "70px",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {item.firstName} {item.lastName}
                              </Typography>
                            }
                            {...getTagProps({ index })}
                          />
                        ))}

                        {extraCount > 0 && (
                          <Chip
                            label={`+${extraCount}`}
                            key="extra-count"
                            size="small"
                          />
                        )}
                      </>
                    );
                  }}
                  renderInput={(params) => (
                    <CustomTextField
                      {...params}
                      label={
                        <>
                          Select Employee{" "}
                          <span style={{ color: "red" }}>*</span>
                        </>
                      }
                      placeholder="Select Employee"
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12}>
                <FormLabel sx={{ fontSize: "13px", color: "text.primary" }}>
                  Pick Date & Time
                </FormLabel>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DateTimePicker
                    sx={{ width: "100%" }}
                    slotProps={{ textField: { size: "small" } }}
                    value={selectedDateTime}
                    onChange={(newValue) => handleChangeDateTime(newValue)}
                    minDateTime={dayjs()}
                    desktopModeMediaQuery="@media (max-width: 0px)"
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      color="success"
                      checked={sendReminder}
                      onChange={handleSendReminder}
                    />
                  }
                  label="Send Reminder"
                />
                {sendReminder && (
                  <Box>
                    <CustomTextField
                      select
                      fullWidth
                      value={reminderSelection}
                      onChange={handleReminderChange}
                    >
                      <MenuItem value="select" disabled>
                        Select when to send reminder
                      </MenuItem>
                      <MenuItem value="1 week before">1 Week Before</MenuItem>
                      <MenuItem value="1 day before">1 Day Before</MenuItem>
                      <MenuItem value="1 hour before">1 Hour Before</MenuItem>
                      <MenuItem value="30 minutes before">
                        30 Minutes Before
                      </MenuItem>
                      <MenuItem value="15 minutes before">
                        15 Minutes Before
                      </MenuItem>
                    </CustomTextField>
                  </Box>
                )}
              </Grid>
              <Grid item xs={12}>
                <Box>
                  <label class="switch">
                    <input
                      type="checkbox"
                      checked={chargeReq}
                      onChange={(e) => {
                        handleChargeReq(e.target.checked);
                      }}
                    />
                    <span class="slider round"></span>
                  </label>
                  <FormLabel sx={{ ml: 2 }}>Charge for Assessment</FormLabel>
                </Box>
              </Grid>
              {chargeReq && (
                <Grid item xs={12}>
                  <CustomTextField
                    fullWidth
                    required
                    placeholder="$0.00"
                    label="Assessment Amount"
                    value={assessmentAmount}
                    onChange={(e) => handleChangeAmount(e.target.value)}
                    error={errorAmount}
                    helperText={errorAmount ? "Amount is required" : ""}
                  />
                </Grid>
              )}
            </>
          )}
          {scheduleStep === 2 && (
            <Grid item xs={12}>
              <Typography variant="body1">
                <strong>Assessment {requestID}</strong> has been
                {employee.assignees.length > 0 &&
                  ` assigned to ${employeesList
                    .filter((emp) =>
                      employee.assignees.includes(emp.employeeID)
                    )
                    .map((emp) => `${emp.firstName} ${emp.lastName}`)
                    .join(", ")} and `}
                scheduled for an{" "}
                {assessmentType === "On-Site" ? "onsite" : "oncall"} assessment
                on {formatDate(selectedDateTime)}
              </Typography>
            </Grid>
          )}
        </Grid>
      </DialogContent>
      <DialogActions
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          gap: 2,
          padding: "20px 24px !important",
          boxShadow: `0px -4px 8px rgb(0, 0, 0, 0.1)`,
          zIndex: 1,
        }}
        className="dialog-actions-dense"
      >
        {/* Render Cancel/Skip button only if scheduleStep is not 2 */}
        {scheduleStep !== 2 && (
          <Button variant="contained" color="info" onClick={handleCloseAndSkip}>
            {scheduleStep === 1 && entity === "schedule"
              ? "Cancel"
              : scheduleStep === 1 && entity === "convert"
              ? "Skip for now"
              : ""}
          </Button>
        )}
        <Button
          variant="contained"
          color="main"
          onClick={handleNext}
          disabled={buttonStatus}
        >
          {scheduleStep === 1
            ? isRescheduleMode
              ? "Update"
              : "Schedule"
            : "Okay"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ScheduleAssessment;
